export const PORTRAIT_FACE_FRAME = [
  '[&_[data-slot=capture-frame]]:!aspect-auto [&_[data-slot=capture-frame]]:h-[min(64svh,620px)]',
  'lg:[&_[data-slot=capture-frame]]:h-[585px] lg:[&_[data-slot=capture-frame]]:!max-w-[400px]',
  '[--capture-status-bottom:auto] [&_[data-slot=capture-status]]:top-3',
  '[--capture-status-font-size:14px] [--capture-status-px:14px] [--capture-status-py:6px]',
].join(' ');
